// src/components/TaskCard.js
import React from 'react';
import '../styles/TaskCard.css';
import { baseUrl } from '../config';



const TaskCard = ({ task }) => {
  return (
    <div className="task-card">
      <h3 className="task-title">{task.title}</h3>
      <p className="task-desc">{task.description}</p>
      <p className="task-info">Due date: {task.dueDate}</p>
      <p className="task-info">Assigned to: {task.assignedTo}</p>
      <div className="progress-bar-container">
        <div
          className="progress-bar"
          style={{ width: `${task.completionPercentage}%` }}
        ></div>
        <span className="progress-percent">{task.completionPercentage}%</span>
      </div>
    </div>
  );
};

export default TaskCard;

